import { render, staticRenderFns } from "./checklists.vue?vue&type=template&id=80aa4106&scoped=true&lang=html"
import script from "./checklists.vue?vue&type=script&lang=js"
export * from "./checklists.vue?vue&type=script&lang=js"
import style0 from "./checklists.vue?vue&type=style&index=0&id=80aa4106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80aa4106",
  null
  
)

export default component.exports